<template>
    <b-modal id="modalPecas" data-backdrop="static" data-keyboard="false" size="xl" v-model="exibirItens" centered>
        <template #modal-header>
            <div class="col-10">
                <h4>Registre os materiais que você utilizou!</h4>
            </div>
        </template>
        <div id="totalPecas">
            <os-item-pecas
                :os="os" 
                v-for="(item, index) in items" 
                :key="index" 
                :item="item"
                :initAt=initAtendimento>
            </os-item-pecas>
        </div>
        <template #modal-footer>
            <div class="w-100">
                <div class="row center" style="justify-content: center; ">
                    <b-button class="mr-2" variant="danger" size="lg" @click="$emit('showModalPecas')">
                        Fechar
                    </b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>
import OsItemPecas from '@/components/Preventivas/OsItemPecas'

export default {
    name: 'ModalItems',
    props: {
        items: {}
    },
    components: {
        OsItemPecas,
    },
    data() {
        return {
            exibirItens: true,
            initAtendimento: false,
        }
    },

    methods: {

    },

    computed: {
        // items () {
        //     return this.$store.getters['osItem/itemsPreventiva']
        // },
        os () {
            const os = this.$store.getters['os/details']

            if (!os) {
                return {}
            }
            return os
        },
    },

    created() {
    },
}
</script>
<style scoped>
#modalPecas {
    pointer-events: none !important;
    height: 750px !important;
}

.close {
    display: none !important;
}

.modal-footer{
    margin-bottom: 20px;
}

#totalPecas {
    height: 466px !important;
    overflow-x: auto !important;
}

.modal-content {
    height: 700px !important;
}
</style>